import { defineStore } from 'pinia'

export const deviceEnum = {
  mobile: 'MOBILE',
  pad: 'PAD',
  pc: 'PC'
}

export const usePageResizeStore = defineStore('pageResize', {
  state: () => ({
    isMobile: true,
    device: deviceEnum.mobile
  }),
  actions: {
    setIsMobile(value) {
      this.isMobile = value
    },
    setDevice(value) {
      this.device = value
    },
    handleResize() {
      const width = document.body.clientWidth
      if (width < 900) {
        this.setDevice(deviceEnum.mobile)
        this.setIsMobile(true)
      } else if (width < 1440) {
        this.setDevice(deviceEnum.pad)
        this.setIsMobile(false)
      } else {
        this.setDevice(deviceEnum.pc)
        this.setIsMobile(false)
      }
    },
    onListenerResize() {
      this.handleResize()
      window.removeEventListener('resize', this.handleResize)
      window.addEventListener('resize', this.handleResize)
    }
  }
})
